import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
// application
import SearchContent from './SearchContent';
import PageTitle from '../../shared/PageTitle';

function Search(props) {
    const { layout } = props;
    let content;
    if (layout === 'classic') {
        content = (
            <SearchContent layout={layout} />
        );
    } else if (layout === 'full') {
        content = (
            <div className="row justify-content-center">
                <div className="col-md-12 col-lg-8 col-xl-8">
                    <SearchContent layout={layout} />
                </div>
            </div>
        );
    }

    return (
        <div className="search-form">
            <PageTitle header={<FormattedMessage id="Search.name" defaultMessage="Kërko" />} />
            {content}
        </div>
    );
}

Search.propTypes = {
    layout: PropTypes.oneOf(['classic', 'full']),
};

Search.defaultProps = {
    layout: 'classic',
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(Search);
